var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 7H10C8.3 7 7 8.3 7 10V22C7 23.7 8.3 25 10 25H22C23.7 25 25 23.7 25 22V10C25 8.3 23.7 7 22 7ZM16 13C17.7 13 19 14.3 19 16C19 17.7 17.7 19 16 19C14.3 19 13 17.7 13 16C13 14.3 14.3 13 16 13ZM19.8 11C19.8 10.3 20.4 9.8 21 9.8C21.6 9.8 22.2 10.4 22.2 11C22.2 11.6 21.7 12.2 21 12.2C20.3 12.2 19.8 11.7 19.8 11V11ZM22 23H10C9.4 23 9 22.6 9 22V16H11C11 18.8 13.2 21 16 21C18.8 21 21 18.8 21 16H23V22C23 22.6 22.6 23 22 23Z",
    fill: "#1B1B1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/In.d4f356992c812c94a740f837a42df8ba.svg";
export { ForwardRef as ReactComponent };